import type { StaticSharedField } from './types';
import {
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_TXT,
} from '/business/shared/components/questions/helper/fieldEnums';

export default function useEmissionSource({
  subLabel,
  sourceErrMsg,
}: {
  subLabel?: string;
  sourceErrMsg?: string;
}): StaticSharedField {
  return {
    propName: 'emission_source',
    element: 'emission_source',
    type: FIELD_TYPE_TXT,
    label: 'Emission source:',
    subLabel: subLabel ? <span>{subLabel}</span> : null,
    placeholderI18nKey: ' ',
    validation: [
      {
        rule: ERR_TYPE_REQUIRED,
        errCode: 'ERRNOEMISSIONSOURCE',
        errStr: sourceErrMsg || 'Please enter a valid name or identifier',
      },
      {
        rule: ERR_TYPE_STR_SHORT,
        errCode: 'ERREMISSIONSOURCETOOSHORT',
        errStr: sourceErrMsg || 'Please enter a valid name or identifier',
        value: 3,
      },
      {
        rule: ERR_TYPE_STR_LONG,
        errCode: 'ERREMISSIONSOURCETOOLONG',
        errStr: sourceErrMsg || 'Please enter a valid name or identifier',
        value: 100,
      },
    ],
  };
}
